import Cookies from 'js-cookie';

import { REFRESH_TOKEN_EXPIRATION_TIME, ACCESS_TOKEN_EXPIRATION_TIME } from '~/domains/auth/consts';

function setTokens({
  accessToken,
  refreshToken,
}: {
  accessToken: string;
  refreshToken?: string;
}) {
  Cookies.set('accessToken', accessToken, {
    expires: ACCESS_TOKEN_EXPIRATION_TIME,
  });

  if (refreshToken) {
    Cookies.set('refreshToken', refreshToken, {
      expires: REFRESH_TOKEN_EXPIRATION_TIME,
    });
  }

  Cookies.set('isLoggedIn', 'true', {
    expires: REFRESH_TOKEN_EXPIRATION_TIME,
    domain: '.splashsports.com',
    secure: true,
    sameSite: 'strict',
  });
}

export { setTokens };
